import Vue from "vue";
import VueRouter from "vue-router";
// import goTo from 'vuetify/es5/services/goto'
// import store from "../store";
import store from "../stores/store";
import cookieConsent from "@/mixins/cookieConsent/index.js";

// import About from '../views/About.vue'

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: { name: "home" },
  },
  {
    path: "/home",
    name: "home",
    component: () => import(/* webpackChunkName: "about" */ "../views/Home.vue"),
  },
  {
    path: "/sign-in",
    name: "sign_in",
    component: () => import(/* webpackChunkName: "UserSignIn" */ "../views/UserSignIn.vue"),
  },
  {
    path: "/sign-up",
    name: "sign_up",
    component: () => import(/* webpackChunkName: "UserSignUp" */ "../views/UserSignUp.vue"),
  },
  {
    path: "/user/",
    name: "user_profile",
    component: () => import(/* webpackChunkName: "UserProfile" */ "../views/UserProfile.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: "/user/edit",
    name: "user_edit",
    component: () => import(/* webpackChunkName: "UserEdit" */ "../views/UserEdit.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: "/account-deleted",
    name: "account_deleted",
    component: () => import(/* webpackChunkName: "AccountDeleted" */ "../views/AccountDeleted.vue"),
  },
  {
    path: "/forgot-password/",
    name: "forgot_password",
    component: () => import(/* webpackChunkName: "ForgotPassword" */ "../views/UserForgotPassword.vue"),
  },
  {
    path: "/about",
    name: "about",
    component: () => import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/chats",
    name: "chats",
    component: () => import(/* webpackChunkName: "chats" */ "../views/Chats.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: "/posts",
    name: "posts",
    component: () => import(/* webpackChunkName: "Posts" */ "../views/Posts.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: "/events",
    name: "events",
    component: () => import(/* webpackChunkName: "Events" */ "../views/Events.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: "/legal/",
    name: "legal",
    component: () => import(/* webpackChunkName: "Legal" */ "../views/Legal.vue"),
  },
  {
    path: "/surveys",
    name: "surveys",
    component: () => import(/* webpackChunkName: "Surveys" */ "../views/Surveys.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: "/cms_pages/:id",
    name: "cms_page",
    component: () => import(/* webpackChunkName: "CmsPage" */ "../views/CmsPage.vue"),
  },
  {
    path: "/organisations/:id",
    name: "organisation",
    component: () => import(/* webpackChunkName: "CmsPage" */ "../views/Organisation.vue"),
  },
  {
    path: "/event/:id",
    name: "event",
    component: () => import(/* webpackChunkName: "CmsPage" */ "../views/Event.vue"),
  },
  {
    path: "/organisations/",
    name: "organisations",
    component: () => import(/* webpackChunkName: "CmsPage" */ "../views/Organisations.vue"),
  },
  {
    path: "/contact/",
    name: "contact",
    component: () => import(/* webpackChunkName: "Contact" */ "../views/Contact.vue"),
  },
  {
    path: "/welcome/",
    name: "welcome",
    component: () => import(/* webpackChunkName: "Welcome" */ "../views/Welcome.vue"),
  },
  {
    path: "/terms-and-conditions/",
    name: "app_terms",
    component: () => import(/* webpackChunkName: "Terms" */ "../views/TermsInApp.vue"),
  },
  {
    path: "/privacy/",
    name: "app_privacy",
    component: () => import(/* webpackChunkName: "Search" */ "../views/PrivacyInApp.vue"),
  },
  {
    path: "/accessibility/",
    name: "app_accessibility",
    component: () => import(/* webpackChunkName: "Search" */ "../views/AccessibilityInApp.vue"),
  },
  {
    path: "/app-search/",
    name: "search",
    component: () => import(/* webpackChunkName: "Search" */ "../views/AppSearch.vue"),
  },
  {
    path: "/favourites",
    name: "favourites",
    component: () => import(/* webpackChunkName: "Search" */ "../views/Favourites.vue"),
  },
  {
    path: "/vips",
    name: "vips",
    component: () => import(/* webpackChunkName: "Search" */ "../views/Vips.vue"),
  },
  {
    path: "/infoandadvice",
    name: "infoandadvice",
    component: () => import(/* webpackChunkName: "Search" */ "../views/InfoAndAdvice.vue"),
  },
  {
    path: "/live-apprenticeships",
    name: "opportunities",
    component: () => import(/* webpackChunkName: "Search" */ "../views/Opportunities.vue"),
  },
  {
    path: "/live-apprenticeship/:id",
    name: "Opportunity",
    component: () => import(/* webpackChunkName: "Search" */ "../views/Opportunity.vue"),
  },
  {
    path: "/education-training-work",
    name: "education_training_work",
    component: () => import(/* webpackChunkName: "Search" */ "../views/EducationTrainingWork.vue"),
  },
  {
    path: "/mental-health-toolkit",
    name: "toolkit",
    component: () =>
      import(/* webpackChunkName: "Toolkit" */ "../views/Toolkit.vue"),
  },
  {
    path: "/mental-health-toolkit/archive/:category",
    name: "toolkit_archive",
    component: () =>
      import(
        /* webpackChunkName: "ToolkitArchive" */ "../views/ToolkitArchive.vue"
      ),
  },
  {
    path: "/mental-health-toolkit/search/:search",
    name: "toolkit_search",
    component: () =>
      import(
        /* webpackChunkName: "ToolkitSearch" */ "../views/ToolkitSearch.vue"
      ),
  },
  {
    path: "/mental-health-toolkit/:id",
    name: "toolkit_article",
    component: () =>
      import(
        /* webpackChunkName: "ToolkitArticle" */ "../views/ToolkitArticle.vue"
      ),
  },
  {
    path: "/education",
    name: "education",
    component: () =>
      import(/* webpackChunkName: "Education" */ "../views/Education.vue"),
  },
  {
    path: "/education/:id",
    name: "education_article",
    component: () =>
      import(
        /* webpackChunkName: "Education" */ "../views/EducationArticle.vue"
      ),
  },
  {
    path: "*",
    name: "not_found",
    component: () => import(/* webpackChunkName: "Search" */ "../views/NotFound.vue"),
  },
  {
    path: "/offers",
    name: "offers_archive",
    component: () => import(/* webpackChunkName: "OffersArchive" */ "../views/OffersArchive.vue"),
  },
  {
    path: "/offer/:id",
    name: "offers_article",
    component: () => import(/* webpackChunkName: "OffersArticle" */ "../views/OffersArticle.vue"),
  },
  {
    path: "/budget-planner",
    name: "budget_planner",
    component: () => import(/* webpackChunkName: "BudgetPlanner" */ "../views/BudgetPlanner.vue"),
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      console.log(savedPosition.y);
      setTimeout(function () {
        console.log("scrolling!!");
        window.scroll(0, savedPosition.y);
      }, 50);
      return;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes,
});

router.beforeEach((to, from, next) => {
  const isWelcomePage = to.name === "welcome";
  const isPrivacyPage = to.name === "app_privacy";
  const hasRequiredData = localStorage.getItem("current_lang") && localStorage.getItem("terms_accepted");
  const isApp = window.cordova;

  if (!isWelcomePage && !hasRequiredData && !isPrivacyPage) {
    next({ name: "welcome" });
  } else if (isWelcomePage && hasRequiredData) {
    next({ name: "home" });
  } else {
    next();
  }

  // initialize cookie consent if not on the welcome page and all required data is present
  if (!isApp && !isWelcomePage && hasRequiredData) {
    cookieConsent.methods.initCookieConsent();
  }
});

function requireAuth(to, from, next) {
  if (store.getters["user/isTokenSet"]) {
    next();
  } else {
    next({
      path: "/sign-in",
      query: { redirect: to.name },
    });
  }
}

export default router;
